import {
  SuggestedConnection,
  loadConnectionSuggestions,
  sendConnection,
  sendConnectionSuggestionFeedback,
  withAsyncThunkErrorHandling,
} from '@lib/store';

import {useAppDispatch} from '@hooks';
import {useTranslation} from 'react-i18next';
import {Avatar, Button, IconButton} from '@molecules';

export const ConnectionSuggestionItem = ({
  connectionSuggestion,
  feedbackData,
}: {
  connectionSuggestion: SuggestedConnection;
  feedbackData: {userId: string; suggestionId: string; created: string; serveId: string};
}) => {
  const {t} = useTranslation();
  const dispatch = useAppDispatch();
  const {connectedUser, numberOfCommonFriends} = connectionSuggestion;

  const handleConnect = async () => {
    dispatch(
      withAsyncThunkErrorHandling(() =>
        sendConnectionSuggestionFeedback({
          ...feedbackData,
          userIdSuggestedConnection: connectionSuggestion.connectedUser.id,
          approved: true,
        }),
      ),
    );
    await dispatch(
      withAsyncThunkErrorHandling(() =>
        sendConnection({connectionId: connectedUser.connectionId, userId: connectedUser.id}),
      ),
    );
    dispatch(loadConnectionSuggestions());
  };

  const handleIgnore = async () => {
    await dispatch(
      withAsyncThunkErrorHandling(() =>
        sendConnectionSuggestionFeedback({
          ...feedbackData,
          userIdSuggestedConnection: connectionSuggestion.connectedUser.id,
          approved: false,
        }),
      ),
    );
    dispatch(loadConnectionSuggestions());
  };

  return (
    <div className="grid grid-cols-[auto_1fr_auto] gap-4 items-center w-full py-4 last:pb-0">
      <Avatar
        user={connectedUser}
        size="large"
        className="shadow-mapiq-small"
      />

      <div className="flex flex-col">
        <h4>{connectedUser.name}</h4>
        <p className="text-mapiq-black-500">{t('connection:MutualConnection', {count: numberOfCommonFriends})}</p>
      </div>

      <IconButton
        className="self-start"
        aria-label={t('connection:IgnoreConnection')}
        iconButton="tertiary"
        icon="close"
        onClick={handleIgnore}
        size="xsmall"
      />

      <div className="col-start-2 flex items-center gap-4">
        <Button
          button="primary"
          size="small"
          onClick={handleConnect}>
          {t('connection:Connect')}
        </Button>
      </div>
    </div>
  );
};
